import { Avatar, Card, CardContent, Grid, Skeleton, Typography } from "@mui/material";
import { AppImageDimension, AppImages } from "app/appImages";
import { MprcContainer, MprcRequestErrorReport } from "components";
import { TrainingAssessmentItemDto } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import { useEffect, useState } from 'react';
import { ActionButtonAssessment } from "./TrainingAssessmentActions";
import { TrainingAssessmentDataBox } from "./TrainingAssessmentDataBox";

interface IProps {
    enrollmentId: string;
    componentId: string;
    onComplete: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////

export const AssessmentContent = (props: IProps) => {

    const { enrollmentId, componentId } = props;

    const api = useCoreApi();

    const [loading, setLoading] = useState<boolean>(true);
    const [viewError, setViewError] = useState<any>();
    const [reload, setReload] = useState<boolean>(false);
    const [assessment, setAssessment] = useState<TrainingAssessmentItemDto>();

    /////////////////////////////////////////////////////////////////////////////////////
    /// EFFECT'S
    /////////////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        async function getData() {
            try {
                setLoading(true);
                const response = await api.v1.lmsTraining.getTrainingAssessmentItem({ enrollmentId, componentId });
                setAssessment(response.data);
            } catch (error) {
                setViewError(error);
            }
            finally {
                setLoading(false);
                setReload(false);
            }
        }

        getData();
    }, [enrollmentId, componentId, reload]);

    /////////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    /////////////////////////////////////////////////////////////////////////////////////

    return (
        <>
            {loading
                ? <Skeleton variant="rectangular" width="100%" height={"200px"} />
                :
                viewError
                    ? <MprcRequestErrorReport error={viewError} />
                    : assessment && <MprcContainer>
                        <Card>
                            <CardContent sx={{ p: 2 }}>
                                <Grid container direction="column" spacing={1}>
                                    <Grid>
                                        <Typography variant="h5" component="span">
                                            {assessment.name}
                                        </Typography>
                                    </Grid>
                                    <Grid>
                                        <Grid container spacing={2}>
                                            <Grid>
                                                <Grid container direction="column" spacing={1} alignItems="center">
                                                    <Grid>
                                                        <Avatar
                                                            variant="rounded"
                                                            sx={{ ...AppImageDimension.ThumbnailLg }}
                                                            src={assessment.thumbnailUrl == null
                                                                ? AppImages.AssessmentEvaluationThumbnail
                                                                : assessment.thumbnailUrl
                                                            }
                                                        />
                                                    </Grid>
                                                    <Grid sx={{ width: 220 }}>
                                                        <ActionButtonAssessment
                                                            assessment={assessment}
                                                            enrollmentId={enrollmentId}
                                                            componentId={componentId}
                                                            onRefresh={() => setReload(true)}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid>
                                                <TrainingAssessmentDataBox
                                                    assessment={assessment}
                                                    enrollmentId={enrollmentId}
                                                    componentId={componentId}
                                                    onReload={() => setReload(true)}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </MprcContainer>
            }
        </>
    );
};
